import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import memoizeImmutable from '@/common/memoizeImmutable';

reframe.regSub('nikeone.menuNotLoadedYet', db => !db.getIn(['nikeone', 'menu']));

reframe.regSub('nikeone.bettingDays', db => db.getIn(['nikeone', 'bettingDays']));

reframe.regSub('nikeone.menu', db => db.getIn(['nikeone', 'menu'], Immutable.Map()));

reframe.regSub('nikeone.sportList', db => db.getIn(['nikeone', 'menu', 'sportList'], Immutable.List()));

const emptyReaction = reframe.reaction(function() {});

reframe.regSub(
    'nikeone.sportList.filtered',
    ([_, favOnly]) => [
        reframe.subscribe(['nikeone.menu']),
        favOnly ? reframe.subscribe(['favourite.ids.menuItems']) : emptyReaction
    ],
    ([menu, favBoxIds], [_, favOnly]) => {
        const sportList = menu.getIn(['sportList'], Immutable.List());
        if (!favOnly) {
            return sportList;
        }

        const filtered = sportList.filter(item => {
            return item.get('boxIds', Immutable.Set()).some(boxId => favBoxIds.has(boxId));
        });
        return memoizeImmutable('sportList', filtered);
    }
);

reframe.regSub(
    'nikeone.defaultSportSlug.filtered',
    ([_, favOnly]) => [reframe.subscribe(['nikeone.sportList.filtered', favOnly])],
    ([sportList], [_]) => {
        return sportList ? sportList.getIn([0, 'slug']) : sportList;
    }
);

reframe.regSub('nikeone.countryList', (db, [_, sport]) =>
    db.getIn(['nikeone', 'menu', 'countriesBySport', '/' + sport], Immutable.List())
);

reframe.regSub('nikeone.tournamentList', (db, [_, slug]) =>
    db.getIn(['nikeone', 'menu', 'tournamentsBySlug', slug], Immutable.List())
);

reframe.regSub(
    'sub::nikeone.boxIdFromMenu',
    ([_, sportSlugPart]) => reframe.subscribe(['nikeone.tournamentList', sportSlugPart]),
    (tournaments, [_, , slug]) => {
        const matchedTournament = tournaments.find(item => item.slug === slug);
        if (!matchedTournament) {
            return null;
        }
        return matchedTournament.boxId;
    }
);

reframe.regSub(
    'nikeone.tournamentList.split',
    ([_, slug, ,]) => [
        reframe.subscribe(['nikeone.tournamentList', slug]),
        reframe.subscribe(['favourite.ids.menuItems'])
    ],
    ([tournaments, favBoxIds], [_, , favOnly]) => {
        const reduced = tournaments.reduce(
            (acc, tournament) => {
                const fav = favBoxIds.has(tournament.boxId);
                const top = tournament.top;
                // eslint-disable-next-line no-nested-ternary
                const toPush = fav ? acc.favs : top ? acc.tops : acc.others;
                toPush.push(tournament);
                return acc;
            },
            { favs: [], tops: [], others: [] }
        );
        if (favOnly) {
            return { favs: reduced.favs, tops: [], others: [] };
        }
        return reduced;
    }
);

reframe.regSub('nikeone.todayMenu', db => {
    const byDate = db.getIn(['nikeone', 'boxStore', 'filteredBoxStore', 'filter', 'byDate']);
    if (byDate === 'TODAY' || byDate === 'HOUR' || byDate === 'HOURS3') {
        return db.getIn(['nikeone', 'menu']);
    }
    if (byDate === 'ALL') {
        return db.getIn(['nikeone', 'todayMenu']);
    }
    return null;
});
